import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';
import { RequestStatus } from 'types/transport';
import { SystemTransactionHandleAction } from './actions';
import { TransactionHandleAction } from '../actions';

const statusReducer = createReducer<RequestStatus>(RequestStatus.None)
  .handleType(SystemTransactionHandleAction.ArchiveRequest, () => RequestStatus.Creating)
  .handleType(SystemTransactionHandleAction.ArchiveResponse, () => RequestStatus.Success)
  .handleType(SystemTransactionHandleAction.Error, () => RequestStatus.Error)
  .handleType(SystemTransactionHandleAction.RestoreRequest, () => RequestStatus.Creating)
  .handleType(SystemTransactionHandleAction.RestoreResponse, () => RequestStatus.Success)
  .handleType(TransactionHandleAction.MatchRequest, () => RequestStatus.Creating)
  .handleType(TransactionHandleAction.MatchResponse, () => RequestStatus.Success)
  .handleType(TransactionHandleAction.UnmatchRequest, () => RequestStatus.Creating)
  .handleType(TransactionHandleAction.UnmatchResponse, () => RequestStatus.Success);

export default combineReducers({
  status: statusReducer,
});
